import { useFormik } from "formik";
import React, { useState } from "react";
import { ForgotPasswordSchema } from "../../Schemas/LoginSchema";
import { NonAuthRoutes } from "../../constants/Constants";
import ATextField from "../../components/ATextField";
import { Icon, PrimaryButton } from "@fluentui/react";
import { useTranslation } from "react-i18next";
import { generateOTP } from "../../service/UserService";
import { markOtpSent, OTP_FLOW } from "../../helpers/OtpCooldown";
import { encryptData } from "../../helpers/RSAUtility";
import { useNavigate } from "react-router-dom";

const textFieldStyles = {
  errorMessage: {
    color: "#ff0000",
    fontWeight: "700",
    fontSize: "12px",
  },
  fieldGroup: {
    borderRadius: "7px",
  },
  field: {
    ":focus": {
      borderRadius: "7px",
    },
  },
};

const ForgotPassword = () => {
  const [username] = useState("");
  const [isAuthenticated, setIsAuthenticated] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [t] = useTranslation();
  const navigate = useNavigate();
  const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
    useFormik({
      initialValues: {
        username,
      },
      validationSchema: () => ForgotPasswordSchema(t),
      onSubmit: async (values, action) => {
        const encryptedUsername = encryptData(values.username);

        const response = await generateOTP(encryptedUsername);

        // if (response.status === 200) {
        //     console.log(response)
        //     sessionStorage.setItem("forgotPasswordUsername", values.username);
        //     sessionStorage.setItem("forgotPasswordEmail", response.data.data.email);
        //     navigate(NonAuthRoutes.ENTEROTP)
        // } else {
        //   setIsAuthenticated(false);
        //   setErrorMessage(response.data.message);
        // }
        if (response.status === 200) {
          console.log("[ForgotPassword] generateOTP response:", response.data);

          const dto = (response.data && response.data.data) ? response.data.data : {};

          // Stamp the send so the OTP screen's resend countdown runs from here and
          // survives a refresh, instead of restarting whenever that page mounts.
          markOtpSent(OTP_FLOW.FORGOT_PASSWORD);

          // persist username for OTP page
          sessionStorage.setItem("forgotPasswordUsername", values.username);

          // If backend explicitly returned an email (masked) then persist; if empty or emailSent=false, clear old stored email.
          if (typeof dto.emailSent !== "undefined") {
            if (dto.emailSent && dto.email) {
              sessionStorage.setItem("forgotPasswordEmail", dto.email);
              sessionStorage.setItem("forgotPasswordEmailSent", dto.emailSent.toString());
            } else {
              sessionStorage.removeItem("forgotPasswordEmail");
              sessionStorage.removeItem("forgotPasswordEmailSent");
            }
          } else if (dto.email) {
            sessionStorage.setItem("forgotPasswordEmail", dto.email);
          }

          // WhatsApp: persist masked number or clear if not sent
          if (typeof dto.whatsappSent !== "undefined") {
            if (dto.whatsappSent && dto.whatsappNumber) {
              sessionStorage.setItem("forgotPasswordWhatsApp", dto.whatsappNumber);
              sessionStorage.setItem("forgotPasswordWhatsappSent", dto.whatsappSent.toString());
            } else {
              sessionStorage.removeItem("forgotPasswordWhatsApp");
              sessionStorage.removeItem("forgotPasswordWhatsappSent");
            }
          } else if (dto.whatsappNumber) {
            sessionStorage.setItem("forgotPasswordWhatsApp", dto.whatsappNumber);
          }

          // navigate and pass the DTO to Otp so it can pick it up immediately
          navigate(NonAuthRoutes.ENTEROTP, { state: { otpResponse: dto } });
        } else {
          setIsAuthenticated(false);
          setErrorMessage(response.data.message);
        }


        action.resetForm();
      },
    });

  return (
    <>
      <div
        className="ms-Grid container"
        dir="ltr"
        style={{
          height: "100%",
          width: "100%",
          padding: "0px",
          overflowY: "hidden",
          backgroundColor: "white"
        }}
      >
        <div className="ms-Grid-row" style={{ width: "100%", height: "100vh" }}>
          <div
            className="ms-Grid-col ms-xl6 ms-hiddenLgDown"
            style={{ padding: "0", height: "100%" }}
          >
            <img
              className="ai-powered-cloud-image"
              src={`${window.location.origin}/images/AIPoweredCloudPacs.png`}
              alt="AI Powered Cloud Pacs"
            />
          </div>
          <div
            className="ms-Grid-col ms-sm12 ms-md10 ms-lg8 ms-xl4 ms-xlPush1 ms-lgPush2 ms-mdPush1"
            style={{ padding: "0" }}
          >
            <div className="login-form-container">
              <form>
                <p
                  className="ms-fontSize-12 ms-fontWeight-semibold"
                  style={{
                    marginBottom: "20px",
                    lineHeight: "14px",
                  }}
                >
                  {t("authentication.forgot-password-heading")}
                </p>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    margin: "30px 0 5px",
                    color: "#ff0000",
                  }}
                >
                  {!isAuthenticated && (
                    <div
                      className="ms-fontSize-1"
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Icon
                        iconName="InfoSolid"
                        className="ms-fontSize-14"
                        style={{ marginRight: "5px" }}
                      ></Icon>
                      <p className="ms-fontSize-12 login-form-error-messages ms-fontWeight-bold">
                        {errorMessage}
                      </p>
                    </div>
                  )}
                </div>
                <div>
                  <ATextField
                    name="username"
                    label="Username"
                    onChange={handleChange}
                    value={values.username}
                    onBlur={handleBlur}
                    errorMessage={touched.username && errors.username}
                    styles={textFieldStyles}
                  />
                </div>
                <div style={{ marginTop: "30px" }}>
                  <PrimaryButton
                    className="ms-fontSize-14"
                    text={t("button.send-otp")}
                    style={{ width: "175px" }}
                    onClick={handleSubmit}
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
